import React from "react";
import PropTypes from "prop-types";
// import { useState } from "react";

const toInputUppercase = (e) => {
  e.target.value = ("" + e.target.value).toUpperCase();
};

const toProperNoun = (e) => {
  let name = e.target.value;
  let words = name.split(" ");
  for (let i = 0; i < words.length; i++) {
    words[i] =
      words[i].charAt(0).toUpperCase() + words[i].slice(1).toLowerCase();
  }
  e.target.value = words.join(" ");
};

const toPhoneNumber = (e) => {
  var phoneNumberString = e.target.value;
  var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    var intlCode = match[1] ? "+1 " : "";
    return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
  }
  return "";
};

function FormNewContact(props) {

  return (
    <React.Fragment>
      <br />
      <h1>New Contact</h1>
      <hr />
      <div className="form-group">
        <form onSubmit={props.formSubmissionHandler}>
          <div className="row">
            <div className="col">
              <label></label>
              <input
                className="form-control"
                type="text"
                name="firstName"
                placeholder="First Name"
                onInput={toProperNoun}
                
              />
            </div>
            <div className="col">
              <label></label>
              <input
                className="form-control"
                type="text"
                name="lastName"
                placeholder="Last Name"
                onInput={toProperNoun}
                
              />
            </div>

            <div className="col">
              <label></label>
              <input
                className="form-control"
                type="text"
                name="email"
                placeholder="Email"

              />
            </div>
            <div className="col">
              <label></label>
              <input
                className="form-control"
                name="phoneNumber"
                placeholder="Phone Number"
                onInput={toPhoneNumber}
                
              />
            </div>
          </div>

          <br />
          

          <div className="row">
            <div className="col">
              <label></label>
              <input
                className="form-control"
                type="text"
                name="deliveryCity"
                placeholder="City"
                onInput={toProperNoun}
                
              />
            </div>
            <div className="col">
              <label></label>
              <input
                className="form-control"
                type="text"
                name="deliveryRegion"
                placeholder="State/Province"
                maxLength="2"
                onInput={toInputUppercase}
                
              />
            </div>
            <div className="col">
              <label></label>
              <input
                className="form-control"
                type="number"
                name="deliveryZipCode"
                maxLength="5"
                placeholder="Zip Code"
                
              />
            </div>
            <div className="col">
              <label></label>
              <input
                className="form-control"
                type="text"
                name="deliveryCountry"
                placeholder="Country"
                onInput={toProperNoun}
                
              />
            </div>
          </div>
          <br />
          <hr />

          <br />
          <div className="row">
            <div className="col-4">
              <button type="submit">{props.buttonText}</button>
            </div>
          </div>
        </form>
      </div>
    </React.Fragment>
  );
}

FormNewContact.propTypes = {
  formSubmissionHandler: PropTypes.func,
  buttonText: PropTypes.string,
};

export default FormNewContact;
